import { Formik } from "formik";
import PhanHeXuatKho from "../phan-he-xuat-kho/PhanHeXuatKho";
import {EXPORT_CODE} from "../phan-he-xuat-kho/constants/constantsXuatKho";

export const XuatDonThuocBHYT: React.FC = () => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => { }}>
      <>
        <div className="bg-white h-100">
          <div className="flex-1 flex flex-column">
            <PhanHeXuatKho
                whType={EXPORT_CODE.XUAT_HOA_DON}
                className="table-ds-phieu-xuat-donthuoc-bh"
                classNameTablePhieuXuat="h-calc-vh-72"
            />
          </div>
        </div>
      </>
    </Formik>
  );
};

export default XuatDonThuocBHYT;
